import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router-dom";
import { Spin, Card, Button, Typography, Select } from "antd";

import { useQuery } from "../../../../utils";
import UserForm from "../../../../Components/UserForm";
import { getDistricts } from "../../../../actionCreators/DropDown";

import InputLabel from "../../../../Components/FloatingSelectLabel/FloatingSelectLabel";
import Notification from "../../../../Components/Notification"
import { getDistrictAdminDetails, resetUpdateDistrictAdmin, updateDistrictAdmin } from "../../../../actionCreators/DistrictAdmin";
const { Option } = Select;

const getDistrictOptions = (districtList) =>
  districtList?.map((x) => <Option value={x?.id}>{x?.name}</Option>);

function EditDistrictAdmin({
  getDistrictAdminDetails,
  getDistricts,
  districts,
	updateDistrictAdmin,
	resetUpdateDistrictAdmin,
	districtAdminDetails,
	updateDistrictAdminResponse
}) {
  
  const styles = {
    titleButtonParent: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    uploadButton: {
      padding: "7px 18px",
      background: "#284F68",
      color: "white",
      borderRadius: "5px",
      fontWeight: "500",
      fontSize: "15px",
      cursor: "pointer",
      marginRight: "8px",
    },
    contentWrapper: {
      marginLeft: "10px",
      marginRight: "10px",
    },
    titleText: {
      color: "#9e9e9e",
    },
    firstButton: {
      marginRight: "10px",
    },
    assignmentTitle: {
      fontSize: "20px",
    },
  };

  const query = useQuery();

  const handleSubmit = (identityForm, selectedDistrict) => {
    const obj = {
      id: query.get("id"),
      fullName: identityForm?.name,
      email: identityForm?.email,
      phone: identityForm?.phone,
      status: identityForm?.status === 1 ? "active" : "inactive",
      district_id: selectedDistrict,
    };
    updateDistrictAdmin(obj)
  };

  const history = useHistory();
  const [identityForm, setIdentityForm] = React.useState(null);
  const [disableInviteButton, setDisableInviteButton] = React.useState(false);

	const [selectedDistrict, setSelectedDistrict] = React.useState(districtAdminDetails?.data?.data[0]?.district?.id ?? null);
  const [statusSelectActive, setStatusSelectActive] = React.useState(false);


  React.useEffect(() => {
    getDistricts();
  }, []);

  React.useEffect(() => {
    getDistrictAdminDetails({ userId: query.get("id") });
  }, [query]);

  

  React.useEffect(() => {
    if (updateDistrictAdminResponse?.data?.data?.success === true) {
      getDistrictAdminDetails({ userId: query.get("id") });
      Notification(true, 'Success', 'District Admin updated')
      history.goBack()
      resetUpdateDistrictAdmin();
    } else if (updateDistrictAdminResponse?.data?.data?.success === false) {
      Notification(false, 'Error', 'Error in Updation')
      resetUpdateDistrictAdmin();
    }
  }, [updateDistrictAdminResponse])

  if (
    [undefined, null].includes(districtAdminDetails?.data?.data[0]) ||
    districtAdminDetails?.loading || updateDistrictAdminResponse?.loading
  )
    return (
      <div className="spin-loader">
        <Spin size="large" />
      </div>
    );
  else
    return (
      <React.Fragment>
        <div style={styles.titleButtonParent}>
          <div>
            <Typography className="heading">
              <span style={styles.titleText}>District Admin</span>
              {districtAdminDetails?.loading || ` / ${districtAdminDetails?.data?.data[0]?.fullName}`}
            </Typography>
          </div>
          <div>
            <Button
              style={styles.firstButton}
              danger
              color={"orange"}
              size={"large"}
              onClick={() => history.goBack()}
            >
              Cancel
            </Button>
            <Button
              style={!disableInviteButton ? styles.uploadButton : {}}
              type="primary"
              size={"large"}
              onClick={() => handleSubmit(identityForm, selectedDistrict)}
              disabled={disableInviteButton}
            >
              UPDATE
            </Button>
          </div>
        </div>
        <Card bordered={false}>
          <UserForm
            data={districtAdminDetails?.data?.data[0]}
            columnConfig={{
              name: { isRequired: true, isDisabled: false },
              email: { isRequired: true, isDisabled: true },
              phone: { isRequired: true, isDisabled: false },
              status: { isDisabled: false },
            }}
            updateFormState={(x) => setIdentityForm(x)}
            toggleUpdateDisability={(x) => setDisableInviteButton(x)}
            disableStatusAllow={
              districtAdminDetails?.data?.data[0]?.circles?.length > 0 ?? false
            }
          />
          <div style={styles.assignmentTitle}>Assignment</div>
          <div
                onFocus={() => {
                  setStatusSelectActive(true);
                }}
                onBlur={() => {
                  setStatusSelectActive(false);
                }}
                style={{ width: "25%" }}
              >
                <InputLabel
                  value={selectedDistrict}
                  labelText="District"
                  active={statusSelectActive}
                >
                  <Select
                    disabled={false}
                    value={selectedDistrict}
                    onChange={setSelectedDistrict}
                    size="large"
                    loading={districts?.loading ? true : false}
                    allowClear
                  >
                    {getDistrictOptions(districts?.data)}
                  </Select>
                </InputLabel>
              </div>
        </Card>
      </React.Fragment >
    );
}

const mapStateToProps = ({
  districtAdmin: { districtAdminDetails, updateDistrictAdminResponse },
  dropDown: { districts },
}) => ({
  districts,
	districtAdminDetails, 
	updateDistrictAdminResponse
});

const mapDispatchToProps = (dispatch) => ({
  getDistrictAdminDetails: bindActionCreators(getDistrictAdminDetails, dispatch),
  getDistricts: bindActionCreators(getDistricts, dispatch),
  updateDistrictAdmin: bindActionCreators(updateDistrictAdmin, dispatch),
  resetUpdateDistrictAdmin: bindActionCreators(resetUpdateDistrictAdmin, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(EditDistrictAdmin);
